exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * videojs-hls-quality-selector\n * @version 1.1.1\n * @copyright 2020 Chris Boustead (chris@forgemotion.com)\n * @license MIT\n */\n.video-js.vjs-hls-quality-selector{display:block}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/node_modules/css-loader?{"sourceMap":false,"import":false}!/var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/node_modules/videojs-hls-quality-selector/dist/videojs-hls-quality-selector.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../videojs-hls-quality-selector/dist/videojs-hls-quality-selector.css
// module chunks = styles